import { useQuery } from '@tanstack/react-query';
import { rolesClient } from 'api/MinSideClients';
import { RoleResponse, RoleSearchOrderBy, SortOrder } from 'api/minside';
import { SelectOption } from 'common.ui';

export function useRolesQuery(applicationIds?: string[]) {
  return useQuery({
    queryKey: ['roles', applicationIds],
    enabled: applicationIds !== undefined,
    queryFn: async () => {
      const ids = applicationIds ?? [];
      if (ids.length === 0) return [];

      const results = await Promise.all(
        ids.map((id) =>
          rolesClient.apiRolesGet({
            pageNumber: 1,
            pageSize: 9999,
            sortOrder: SortOrder.Ascending,
            orderField: RoleSearchOrderBy.Name,
            applicationId: id
          })
        )
      );

      const allRoles = results.flatMap((r) => r.data ?? []);
      const unique = Array.from(new Map(allRoles.map((r: RoleResponse) => [r.roleId, r])).values());

      return unique
        .sort((a: RoleResponse, b: RoleResponse) => (a.name ?? '').localeCompare(b.name ?? ''))
        .map((d: RoleResponse) => ({ id: d.roleId?.toString(), text: d.name }) as SelectOption);
    },
    staleTime: 5 * 60 * 1000
  });
}
